var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorRound3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_412_20848)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#FBB84D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_412_20848)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#FBB84D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 1.5,
    width: 36,
    height: 34.5,
    rx: 6,
    fill: "url(#paint0_linear_412_20848)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 34.5,
    width: 36,
    height: 1.5,
    rx: 0.75,
    fill: "url(#paint1_linear_412_20848)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_412_20848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6996 7.30015C14.2996 6.93348 15.2496 6.65015 16.5496 6.45015C17.8496 6.25015 18.8829 6.15015 19.6496 6.15015C21.9496 6.15015 23.6663 6.63348 24.7996 7.60015C25.9329 8.56681 26.3663 9.98348 26.0996 11.8501C25.7663 14.1835 24.4496 15.9668 22.1496 17.2001C24.6496 18.0001 25.6829 19.8001 25.2496 22.6001C24.9496 25.0001 23.9496 26.8168 22.2496 28.0501C20.7163 29.1501 18.6996 29.7001 16.1996 29.7001C14.2663 29.7001 12.3996 29.2168 10.5996 28.2501C10.2329 28.0835 9.98294 27.9835 9.84961 27.9501L11.5496 24.6001C11.6496 24.6335 11.8329 24.7335 12.0996 24.9001C12.3996 25.0335 12.7496 25.1668 13.1496 25.3001C14.2496 25.6668 15.2829 25.8501 16.2496 25.8501C17.2496 25.8501 18.1163 25.6001 18.8496 25.1001C19.5829 24.5668 20.0329 23.7335 20.1996 22.6001C20.3996 21.4668 20.1996 20.6668 19.5996 20.2001C19.0329 19.7335 18.3329 19.5001 17.4996 19.5001C16.4996 19.5001 15.4996 19.5001 14.4996 19.5001L14.9996 16.1001H16.1996C17.1996 16.1001 18.1329 15.9668 18.9996 15.7001C19.0663 15.6335 19.1996 15.5335 19.3996 15.4001C19.6329 15.2335 19.8663 15.0168 20.0996 14.7501C20.5996 14.1501 20.9163 13.4168 21.0496 12.5501C21.1829 11.6835 20.9829 11.0335 20.4496 10.6001C19.9163 10.1668 19.2663 9.95015 18.4996 9.95015C17.7663 9.95015 17.1663 10.0001 16.6996 10.1001C16.2663 10.1668 15.8663 10.2501 15.4996 10.3501C14.7996 10.4835 14.3163 10.6168 14.0496 10.7501L13.6996 7.30015Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_412_20848",
    x: 9.84961,
    y: 6.15015,
    width: 16.3262,
    height: 24.4867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.936664
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_412_20848"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_412_20848",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_412_20848",
    x1: 18,
    y1: 1.5,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_412_20848",
    x1: 0,
    y1: 35.25,
    x2: 36,
    y2: 35.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517013,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_412_20848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_412_20848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorRound3);
export default __webpack_public_path__ + "static/media/motor_round_3.bb497902de7c99c8ce75d5202672483e.svg";
export { ForwardRef as ReactComponent };